<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">游戏运营对接</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <FilterCommon :model="model" :isAdd="true" @add="add" @search="search" :isReset="true" @reset="reset"></FilterCommon>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="created_at" label="时间" width="180" />
              <el-table-column prop="game_name" label="游戏名称" width="150" />
              <el-table-column prop="manager_name" label="运营负责人" width="150" />
              <el-table-column prop="game_status_text" label="游戏现状态" width="150" />
              <el-table-column prop="channel_text" label="渠道" width="150" />
              <el-table-column prop="system_text" label="系统" width="150" />
              <el-table-column prop="remark" label="备注" width="150" />
              <el-table-column prop="contact" label="联系方式" width="180" />
              <el-table-column label="操作" width="310">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="primary" @click="remark(scope.row)">备注</el-button>
                  <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
            <el-dialog title="删除" center width="40%" :visible.sync="deleteShow">
              <p style="text-align: center">确认删除吗？</p>
              <div slot="footer" class="dialog-footer">
                <el-button @click="delCancel">取 消</el-button>
                <el-button type="primary" @click="delSure">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 添加弹窗 -->
            <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
            <!-- 备注弹窗 -->
            <Dialog ref="remarkDialog" @submitForm="remarkSure" @closeDialog="closeRemark" :dialogTitle="'备注'" :dialogVisible="remarkVisible" :dialogModel="remarkModel" dialogWidth="700px"></Dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gameManagement, getGameManagementSelect, gameManagementAdd, gameManagementEditInfo, gameManagementEdit, saveGameManagementRemark, gameManagementDel } from '@/api/dpartmentSmmary.js';
import Pagination from '@/components/pagination/index';
import FilterCommon from '../../common/Filter';
import Dialog from '../../common/Dialog';

export default {
  components: {
    Pagination,
    FilterCommon,
    Dialog,
  },
  data() {
    return {
      listQuery: {
        id: 0,
        page: 1,
        limit: 10,
      },
      listLoading: false,
      tableData: [],
      total: 0,
      model: [
        {
          type: 'select',
          label: '游戏名称',
          key: 'game_id_array',
          placeholder: '请选择游戏名称',
          isMultiple: true,
          span: 4,
          options: [],
        },
        {
          type: 'select',
          label: '状态',
          key: 'game_status_array',
          placeholder: '请选择状态',
          isMultiple: true,
          span: 4,
          options: [],
        },
        {
          type: 'select',
          label: '渠道',
          key: 'channel',
          placeholder: '请选择渠道',
          span: 4,
          options: [],
        },
        {
          type: 'select',
          label: '系统',
          key: 'system',
          placeholder: '请选择系统',
          span: 4,
          options: [],
        },
        {
          type: 'input',
          label: '组织负责人',
          key: 'manager_name',
          span: 4,
        },
        {
          span: 5,
          type: 'date-picker',
          label: '日期',
          key: 'date',
          dateType: false,
          empty: false,
          pick: true,
        },
      ],
      dialogVisible: false,
      dialogTitle: '新增',
      dialogModel: [
        {
          type: 'el-select',
          label: '游戏',
          prop: 'game_id',
          options: [],
        },
        {
          type: 'el-select',
          label: '状态',
          prop: 'game_status',
          options: [],
        },
        {
          type: 'el-select',
          label: '渠道',
          prop: 'channel',
          options: [],
        },
        {
          type: 'el-select',
          label: '系统',
          prop: 'system',
          options: [],
          isMultiple: true,
        },
        {
          type: 'el-input',
          label: '组织负责人',
          prop: 'manager_name',
        },
        {
          type: 'el-input',
          label: '联系方式',
          prop: 'contact',
        },
        {
          type: 'el-input',
          label: '备注',
          prop: 'remark',
        },
      ],
      remarkVisible: false,
      remarkModel: [
        {
          type: 'el-input',
          label: '备注',
          prop: 'remark',
        },
      ],
      deleteShow: false,
      deleteId: 0,
    };
  },
  created() {
    this.getList(this.listQuery);
    this.getGameManagementSelect();
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await gameManagement(query);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.listLoading = false;
    },
    // 获取下拉框数据
    async getGameManagementSelect() {
      const { data } = await getGameManagementSelect();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      const { game, status, channel, system } = data.data;
      this.dialogModel[0].options = this.model[0].options = game.map((m) => {
        return { label: m.name, value: m.id };
      });
      this.dialogModel[1].options = this.model[1].options = status.map((m) => {
        return { label: m.type_name, value: m.id };
      });
      this.dialogModel[2].options = this.model[2].options = channel.map((m) => {
        return { label: m.name, value: m.id };
      });
      this.dialogModel[3].options = this.model[3].options = system.map((m) => {
        return { label: m.name, value: m.id.toString() };
      });
    },
    // 添加
    add() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.$refs.dialog.resetForm();
    },
    // 搜索
    search(data) {
      Object.assign(this.listQuery, data, { created_at_begin: data.start_date, created_at_end: data.end_date });
      console.log(this.listQuery);
      delete this.listQuery.id;
      delete this.listQuery.start_date;
      delete this.listQuery.end_date;
      delete this.listQuery.date;
      this.getList(this.listQuery);
    },
    // 重置
    reset() {
      this.listQuery = {
        page: 1,
        limit: 10,
      };
    },
    // 编辑
    async edit(row) {
      const { data } = await gameManagementEditInfo(row.id);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.$refs.dialog.resetForm();
      console.log(data.data);
      this.$refs.dialog.editForm(data.data);
    },
    // 点击确定
    async dialogSure(form) {
      const { data } = this.dialogTitle === '新增' ? await gameManagementAdd(form) : await gameManagementEdit(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getList(this.listQuery);
    },
    // 点击关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 关闭备注弹窗
    closeRemark() {
      this.remarkVisible = false;
      this.$refs.remarkDialog.resetForm();
    },
    // 备注
    async remark(row) {
      const { data } = await gameManagementEditInfo(row.id);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.remarkVisible = true;
      this.$refs.remarkDialog.resetForm();
      this.$refs.remarkDialog.editForm(data.data);
    },
    // 点击修改备注
    async remarkSure(form) {
      const { data } = await saveGameManagementRemark(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改成功');
      this.closeRemark();
      this.getList(this.listQuery);
    },
    // 删除
    async del(row) {
      this.deleteShow = true;
      this.deleteId = row.id;
    },
    // 取消删除
    delCancel() {
      this.deleteId = 0;
      this.deleteShow = false;
    },
    // 删除确定
    async delSure() {
      const { data } = await gameManagementDel(this.deleteId);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.delCancel();
      this.getList(this.listQuery);
    },
  },
};
</script>

<style>
</style>